import { useQuery } from '@tanstack/react-query';
import { useSchoolSchoolyear } from 'containers/App/context/SchoolyearSchoolProvider';
import { CJEvent } from 'types/event';
import {
  EVENTS_KEY,
  getEventsBetweenDates,
} from 'containers/CahierJournal/queries/useCJSeances';
import setHours from 'utils/time/setHours';
import parse from 'utils/time/parse';
import { isoDatePattern } from 'utils/time/datePatterns';
import useClassrooms from 'containers/App/context/ClassroomsContext/useClassrooms';
import { Classroom } from 'types/classroom';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { useQueryErrorNotification } from 'containers/App/Notifications/useQueryErrorNotification';
import { useTranslation } from 'react-i18next';
import { getRandomInt } from 'utils/getRandomInt';

interface Props {
  enabled?: boolean;
  day: string;
}

function getRandomLoadingDatas(date: Date, classrooms: Classroom[]) {
  const nbOfEvents = getRandomInt(3);
  return Array.from({ length: nbOfEvents + 1 }, (_, i) => {
    const event: CJEvent = {
      title: 'Chargement de la séance',
      createdAt: new Date(),
      attachments: [],
      classroomIds: classrooms.map(c => c.id),
      bo: {} as any,
      border: '',
      customFields: [],
      end: setHours(date, 9 + i),
      flow: '',
      id: '',
      linkedFichesDePrep: [],
      materials: [],
      order: 0,
      start: setHours(date, 8 + i),
      status: 'open',
      tag: undefined,
      type: 'loading',
      ateliers: [],
    };
    return event;
  });
}

export function useCJSeancesDay(props: Props) {
  const { day } = props;
  const { t } = useTranslation(['cahierJournal']);

  const { schoolyear, school } = useSchoolSchoolyear();
  const user = useUser();
  const classrooms = useClassrooms();
  const query = useQuery({
    queryKey: [schoolyear.id, school.id, EVENTS_KEY, day],
    queryFn: () =>
      getEventsBetweenDates({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        from: day,
        to: day,
        tz: user.location,
      }),

    placeholderData: getRandomLoadingDatas(
      parse(day, isoDatePattern),
      classrooms,
    ),
    staleTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
  });

  useQueryErrorNotification({
    isError: query.isError,
    message: t('cahierJournal:messages.getError'),
  });

  return query;
}
